import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router-dom'
import queryString from 'query-string'

import './styles.scss'

import searchEngineActions from 'redux/searchEngine/actions'
import SearchInput from './SearchInput'
import LookingFor from './LookingFor'
import PreviousSearches from './PreviousSearches'

const SearchEngine = () => {
  const dispatch = useDispatch()
  const { searchEngine } = useSelector(store => store)
  const { term, termList } = searchEngine
  const [isOpenSuggestions, setIsOpenSuggestions] = useState(false)
  const searchEngineContainerRef = useRef(null)
  const { push } = useHistory()
  const location = useLocation()
  const { q: text } = queryString.parse(location.search)

  useEffect(() => {
    if (text && text !== term) dispatch(searchEngineActions.updateTerm(text))
  }, [text])

  useEffect(() => {
    document.addEventListener('click', closeSuggestionsHandler)
    return () => document.removeEventListener('click', closeSuggestionsHandler)
  }, [searchEngineContainerRef?.current])

  const closeSuggestionsHandler = event => {
    if (!searchEngineContainerRef?.current.contains(event.target)) {
      setIsOpenSuggestions(false)
    }
  }

  const handleOnChange = text => {
    dispatch(searchEngineActions.updateTerm(text))
  }

  const handleSearch = ({ event, value, type }) => {
    if (event) event.preventDefault()
    const searchValue = value || term
    const typeValue = type || 'all'
    if (searchValue < 3) return
    push({
      pathname: '/dashboard/searchresults/',
      search: `?q=${searchValue}&t=${typeValue}`
    })
    dispatch(searchEngineActions.updateTermList({
      method: 'add',
      term: {
        type: typeValue,
        value: searchValue
      }
    }))
    setIsOpenSuggestions(false)
    dispatch(searchEngineActions.updateBackLocation(location))
  }

  return (
    <div
      ref={searchEngineContainerRef}
      className={`search-engine ${isOpenSuggestions ? 'search-engine--open' : ''}`}
    >
      <SearchInput
        isOpenSuggestions={isOpenSuggestions}
        value={term}
        onChange={handleOnChange}
        onSubmit={handleSearch}
        onFocus={() => setIsOpenSuggestions(true)}
      />
      {isOpenSuggestions ? (
        <div className='search-engine__suggestions'>
          <LookingFor handleSearch={handleSearch} />
          {termList?.length ? (
            <PreviousSearches
              previousSearches={termList}
              handleSearch={handleSearch}
            />
          ) : null}
        </div>
      ) : null}
    </div>
  )
}

export default SearchEngine
